import { render } from "./AdBanners.vue?vue&type=template&id=e0cb3fc8&scoped=true"
import script from "./AdBanners.vue?vue&type=script&lang=js"
export * from "./AdBanners.vue?vue&type=script&lang=js"

import "./AdBanners.vue?vue&type=style&index=0&id=e0cb3fc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0cb3fc8"]])

export default __exports__